import { api } from '@utils/api/api'
import { Accounts } from '@interfaces'

export const getBankAccounts = (bankId: string): Promise<Accounts> => {
  return api.get(
    `/api/v1/customers/me/payment-methods/banks/${bankId}/accounts`,
  )
}
